<div class="video-modal-overlay" *ngIf="isOpen" (click)="onBackdropClick($event)">
  <div class="video-modal-content">
    <!-- Botón de cerrar -->
    <button class="close-button" (click)="onCloseModal()">
      <span>&times;</span>
    </button>
    
    <!-- Título -->
    <div class="modal-header">
      <h2>¡Vive la magia acuática en Arequipa!</h2>
    </div>
    
    <!-- Video -->
    <div class="video-container">
      <video 
        [src]="getVideoUrl('videos/la-joya-park.mp4')" 
        controls 
        autoplay
        class="modal-video">
        Tu navegador no soporta el elemento de video.
      </video>
    </div>
  </div>
</div>
